export const SERVER_URL = process.env.REACT_APP_SERVER_URL as string;
export const API_URL = `${SERVER_URL}/api/v1/`;